"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9469],{

/***/ 58635:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(79697);
/* harmony import */ var _mui_material_Box__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(61953);
/* harmony import */ var _mui_material_Typography__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(29630);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(77366);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var components_common_A__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(79592);
/* harmony import */ var components_common_Hidden__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(18450);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  background: url('/img/img_headshot_default.png');\n  background-size: 100%;\n  background-position: center;\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}










const ImgRect = _emotion_styled__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div */ .Z.div(_templateObject(), (param)=>{
    let { theme , $usedInVenderPage  } = param;
    return "\n    position: relative;\n    padding-top: 100%;\n\n    ".concat(theme.breakpoints.up($usedInVenderPage ? "md" : "lg"), " {\n      padding-top: 75%;\n    }\n  ");
});
const Absolute = _emotion_styled__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div */ .Z.div(_templateObject1());
const Img = _emotion_styled__WEBPACK_IMPORTED_MODULE_4__/* ["default"].img */ .Z.img(_templateObject2());
const getLinkFilterByTag = (tagUrlId, extraRouteParams)=>{
    const params = {
        ...extraRouteParams,
        tag: tagUrlId
    };
    return "/album?".concat((0,qs__WEBPACK_IMPORTED_MODULE_5__.stringify)(params));
};
const Album = (param)=>{
    let { album , onClick , onAlbumTagClick , extraRouteParams , usedInVenderPage  } = param;
    var _album_urlId, _album_urlId_toLowerCase;
    const photo = (album === null || album === void 0 ? void 0 : album.representativePhotoInfo) || (album === null || album === void 0 ? void 0 : album.frontCover);
    const image = photo === null || photo === void 0 ? void 0 : photo.image;
    const tags = photo === null || photo === void 0 ? void 0 : photo.tags;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    const albumLink = "/album/".concat((_album_urlId = album.urlId) === null || _album_urlId === void 0 ? void 0 : (_album_urlId_toLowerCase = _album_urlId.toLowerCase) === null || _album_urlId_toLowerCase === void 0 ? void 0 : _album_urlId_toLowerCase.call(_album_urlId)) + ((0,lodash_es__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(extraRouteParams) ? "" : "?".concat((0,qs__WEBPACK_IMPORTED_MODULE_5__.stringify)(extraRouteParams)));
    const onAlbumClick = (e)=>{
        if (onClick) {
            onClick(e, album);
        } else {
            router.push(albumLink);
        }
    };
    const onTagClick = (e, tag)=>{
        e.preventDefault();
        e.stopPropagation();
        if (onAlbumTagClick) {
            onAlbumTagClick(tag);
        } else {
            router.push(getLinkFilterByTag(tag.urlId, extraRouteParams));
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
        display: "flex",
        flexDirection: "column",
        mb: 0,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(components_common_A__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                $origin: true,
                href: albumLink,
                onClick: onAlbumClick,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ImgRect, {
                            $usedInVenderPage: usedInVenderPage,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Absolute, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Img, {
                                    src: image === null || image === void 0 ? void 0 : image.url,
                                    alt: album.name
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                            fontWeight: "fontWeightBold",
                            mt: 3,
                            children: album.name
                        })
                    })
                ]
            }),
            !!(tags === null || tags === void 0 ? void 0 : tags.length) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                mt: 2,
                sx: {
                    display: {
                        xs: "none",
                        ...usedInVenderPage ? {
                            md: "block"
                        } : {
                            lg: "block"
                        }
                    }
                },
                children: tags === null || tags === void 0 ? void 0 : tags.map((tag, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
                        children: [
                            index > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                mx: 2.5,
                                component: "span",
                                color: "text.secondary",
                                children: "|"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_A__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                $textSecondary: true,
                                $nowrap: true,
                                href: getLinkFilterByTag(tag.urlId, extraRouteParams),
                                onClick: (e)=>onTagClick(e, tag),
                                children: tag.name
                            })
                        ]
                    }, tag.urlId))
            })
        ]
    });
};
Album.defaultProps = {
    extraRouteParams: {}
};
/* harmony default export */ __webpack_exports__["Z"] = (Album);


/***/ }),

/***/ 92890:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _mui_material_Grid__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(79072);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93021);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(61303);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(20625);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77366);
/* harmony import */ var components_common_A__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79592);
/* harmony import */ var components_common_SVGElements__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(36406);
/* harmony import */ var components_common_SVGElements__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69854);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}






const Button = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject(), (param)=>{
    let { theme , $checked  } = param;
    return "\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n    width: 32px;\n    height: 29px;\n    color: ".concat($checked ? "white" : theme.palette.text.secondary, ";\n    background-color: ").concat($checked ? theme.palette.primary.main : "white", ";\n    border-radius: ").concat(theme.spacing(1), ";\n    border: 1px solid ").concat($checked ? theme.palette.primary.main : "white", ";\n\n    &:hover {\n      border-color: ").concat(theme.palette.text.secondary, ";\n    }\n  ");
});
const Pagination = (param)=>{
    let { page , setPage , pageAmount , urlPath  } = param;
    let startPage = (0,lodash_es__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)([
        [
            (p)=>p === 1,
            ()=>1
        ],
        [
            (p)=>p === 2 || p === 3,
            ()=>2
        ],
        [
            (p)=>p > 3,
            (p)=>p + 2 > pageAmount ? (0,lodash_es__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)([
                    pageAmount - 4,
                    1
                ]) : p - 2
        ],
        [
            ()=>true,
            ()=>1
        ]
    ])(page);
    const length = (0,lodash_es__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)([
        5,
        pageAmount - startPage + 1
    ]);
    const paginations = Array.from({
        length
    }, (_, i)=>i + startPage);
    const onPrevClick = ()=>setPage((0,lodash_es__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)([
            page - 1,
            1
        ]));
    const onNextClick = ()=>setPage((0,lodash_es__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)([
            page + 1,
            pageAmount
        ]));
    const abortLinkClick = (e)=>e.preventDefault();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
            container: true,
            spacing: 1,
            children: [
                page !== 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                            item: true,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_A__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                onClick: abortLinkClick,
                                href: !!urlPath ? "".concat(urlPath, "?page=").concat((0,lodash_es__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)([
                                    page - 1,
                                    1
                                ])) : "",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Button, {
                                    onClick: onPrevClick,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_SVGElements__WEBPACK_IMPORTED_MODULE_8__/* .ArrowLeft */ .X, {
                                        textSecondary: true
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                            item: true,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_A__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                onClick: abortLinkClick,
                                href: !!urlPath ? "".concat(urlPath, "?page=1") : "",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Button, {
                                    onClick: ()=>setPage(1),
                                    children: "1"
                                })
                            })
                        })
                    ]
                }),
                paginations === null || paginations === void 0 ? void 0 : paginations.map((pagination)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                        item: true,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_A__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            onClick: abortLinkClick,
                            href: !!urlPath ? "".concat(urlPath, "?page=").concat(pagination) : "",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Button, {
                                $checked: page === pagination,
                                onClick: ()=>setPage(pagination),
                                children: pagination
                            })
                        })
                    }, "page-".concat(pagination))),
                page < pageAmount && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                    item: true,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_A__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        onClick: abortLinkClick,
                        href: !!urlPath ? "".concat(urlPath, "?page=").concat((0,lodash_es__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)([
                            page + 1,
                            pageAmount
                        ])) : "",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Button, {
                            onClick: onNextClick,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_SVGElements__WEBPACK_IMPORTED_MODULE_9__/* .ArrowRight */ .o, {
                                textSecondary: true
                            })
                        })
                    })
                })
            ]
        })
    });
};
Pagination.defaultProps = {
    page: 1,
    pageAmount: 1
};
/* harmony default export */ __webpack_exports__["Z"] = (Pagination);


/***/ }),

/***/ 36406:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ ArrowLeft; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _SVG__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54806);


const ArrowLeft = (props)=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SVG__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        xmlns: "http://www.w3.org/2000/sv g",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
            className: "arrow_left_24",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                d: "M15.707 5.293a1 1 0 010 1.414L10.414 12l5.293 5.293a1 1 0 01-1.414 1.414l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 0z",
                className: "Vector (Stroke)",
                clipRule: "evenodd"
            })
        })
    });
};


/***/ }),

/***/ 69854:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ ArrowRight; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _SVG__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54806);


const ArrowRight = (param)=>{
    let { color , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SVG__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        $color: color,
        ...props,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
            className: "arrow_right_24l",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                d: "M8.293 5.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L13.586 12 8.293 6.707a1 1 0 010-1.414z",
                className: "Vector (Stroke)",
                clipRule: "evenodd"
            })
        })
    });
};


/***/ }),

/***/ 89469:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89289);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(61225);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(62097);
/* harmony import */ var _mui_material_Box__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(61953);
/* harmony import */ var _mui_material_Grid__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(79072);
/* harmony import */ var react_infinite_scroll_component__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(58533);
/* harmony import */ var react_lazyload__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1216);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(61303);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(27961);
/* harmony import */ var store_webview_webviewSlice__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(86377);
/* harmony import */ var utils_api_hooks__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(55108);
/* harmony import */ var utils_api_hooks__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(10920);
/* harmony import */ var utils_hooks__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(13946);
/* harmony import */ var components_common_AlbumListItem__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(58635);
/* harmony import */ var components_common_Pagination__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(92890);
/* harmony import */ var components_common_Modal__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(37524);
/* harmony import */ var components_common_Hidden__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(18450);
/* harmony import */ var utils_hooks_analytics__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(27582);




















const DynamicAlbumContent = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(()=>Promise.all(/* import() */[__webpack_require__.e(2334), __webpack_require__.e(2411)]).then(__webpack_require__.bind(__webpack_require__, 22334)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(22334)
            ]
    }
});
const NUMBER_PER_PAGE = 30;
const Albums = (param)=>{
    let { venderId , containerId , isMobile , count , nativeHeaderControlHandler  } = param;
    const [page, setPage] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(1);
    const { data: paginatedAlbums  } = (0,utils_api_hooks__WEBPACK_IMPORTED_MODULE_13__/* .useAlbums */ .L)(()=>{
        if (isMobile) {
            return null;
        }
        return {
            venderId,
            skip: (0,lodash_es__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)([
                page - 1,
                0
            ]) * NUMBER_PER_PAGE,
            limit: NUMBER_PER_PAGE
        };
    });
    const { data: infiniteAlbums , size , setSize  } = (0,utils_api_hooks__WEBPACK_IMPORTED_MODULE_15__/* .useInfiniteAlbums */ .$)(()=>{
        if (!isMobile) {
            return null;
        }
        return {
            venderId,
            limit: NUMBER_PER_PAGE
        };
    });
    const albums = (0,lodash_es__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(isMobile ? infiniteAlbums : paginatedAlbums);
    const onLoadMore = ()=>setSize(size + 1);
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    const webview = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(store_webview_webviewSlice__WEBPACK_IMPORTED_MODULE_7__/* .selectWebview */ .hn);
    const albumModalOptions = {
        webview,
        nativeHeaderControlHandler
    };
    const { albumModal , closeAlbumModal , onAlbumClick , onAlbumContentClose  } = (0,utils_hooks__WEBPACK_IMPORTED_MODULE_8__/* .useAlbumModal */ .Xh)(router.asPath, router, albumModalOptions);
    const handleAlbumClick = (event, album)=>{
        var _album_vender;
        if (!album) {
            onAlbumClick(event, album);
            return;
        }
        utils_hooks_analytics__WEBPACK_IMPORTED_MODULE_17__/* .GtmAgent.directSendToGTM */ .b.directSendToGTM({
            event: "living_action",
            living_event_name: "booking_service_photoalbum",
            living_click_name: album === null || album === void 0 ? void 0 : album.name,
            living_click_location: "廠商頁",
            living_vender: album === null || album === void 0 ? void 0 : (_album_vender = album.vender) === null || _album_vender === void 0 ? void 0 : _album_vender.name,
            living_click_photoalbum_id: album === null || album === void 0 ? void 0 : album._id
        });
        onAlbumClick(event, album);
    };
    const theme = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)();
    const isLgUp = (0,_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)((theme)=>theme.breakpoints.up("lg"));
    // 根據螢幕大小限制顯示的專輯數量
    const displayedAlbums = isLgUp ? albums.slice(0, 8) : albums.slice(0, 6);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_infinite_scroll_component__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                dataLength: (albums === null || albums === void 0 ? void 0 : albums.length) || 0,
                hasMore: true,
                next: onLoadMore,
                scrollableTarget: containerId,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                    overflow: "hidden",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .ZP, {
                        container: true,
                        spacing: {
                            xs: 4,
                            lg: 6
                        },
                        children: displayedAlbums === null || displayedAlbums === void 0 ? void 0 : displayedAlbums.map((album)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .ZP, {
                                item: true,
                                xs: 6,
                                lg: 3,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_lazyload__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, {
                                        height: 350,
                                        offset: 350,
                                        scrollContainer: "#".concat(containerId),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_AlbumListItem__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                            album: album,
                                            onClick: handleAlbumClick,
                                            usedInVenderPage: true
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("noscript", {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("style", {
                                                children: ".lazyload-placeholder { display: none; }"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_AlbumListItem__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                                album: album,
                                                onClick: handleAlbumClick,
                                                usedInVenderPage: true
                                            })
                                        ]
                                    })
                                ]
                            }, album._id))
                    })
                })
            }),
            (router === null || router === void 0 ? void 0 : router.isReady) && albumModal.open && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_Modal__WEBPACK_IMPORTED_MODULE_11__/* .FullscreenModal */ .OW, {
                open: albumModal.open,
                onClose: closeAlbumModal,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DynamicAlbumContent, {
                    onClose: onAlbumContentClose,
                    closeModal: closeAlbumModal,
                    fallbackData: albumModal.fallbackData
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Albums);


/***/ }),

/***/ 55108:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ useAlbums; }
/* harmony export */ });
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var utils_hooks_fetchers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86700);


const useAlbums = (props, swrOptions)=>{
    const genUrl = ()=>{
        try {
            const propsObject = typeof props === "function" ? props() : props;
            if (propsObject === null) {
                return null;
            }
            return "/albums?".concat((0,qs__WEBPACK_IMPORTED_MODULE_0__.stringify)({
                ...propsObject,
                limit: 30
            }));
        } catch (err) {
            return null;
        }
    };
    return (0,utils_hooks_fetchers__WEBPACK_IMPORTED_MODULE_1__/* .useCustomSWR */ .LW)(genUrl, swrOptions);
};


/***/ }),

/***/ 10920:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ useInfiniteAlbums; }
/* harmony export */ });
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var utils_hooks_fetchers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86700);


const useInfiniteAlbums = (props, swrOptions)=>{
    const getAlbumsKey = (opts)=>(pageIndex, previousPageData)=>{
            const propsObject = typeof opts === "function" ? opts() : opts;
            if (propsObject === null) {
                return null;
            }
            if (previousPageData && !previousPageData.length) {
                return null;
            }
            const limit = propsObject.limit || 30;
            const params = {
                ...propsObject,
                limit: limit,
                skip: pageIndex * limit
            };
            return "/albums?".concat((0,qs__WEBPACK_IMPORTED_MODULE_0__.stringify)(params));
        };
    const { data , ...rest } = (0,utils_hooks_fetchers__WEBPACK_IMPORTED_MODULE_1__/* .useCustomSWRInfinite */ .KU)(getAlbumsKey(props), swrOptions);
    // data會無預期出現數字，不確定為什麼，
    // 先避免直接回傳錯誤的資料類型
    return {
        data: typeof data === "number" ? [] : data,
        ...rest
    };
};


/***/ }),

/***/ 58000:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _isSymbol_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72714);


/**
 * The base implementation of methods like `_.max` and `_.min` which accepts a
 * `comparator` to determine the extremum value.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The iteratee invoked per iteration.
 * @param {Function} comparator The comparator used to compare values.
 * @returns {*} Returns the extremum value.
 */
function baseExtremum(array, iteratee, comparator) {
  var index = -1,
      length = array.length;

  while (++index < length) {
    var value = array[index],
        current = iteratee(value);

    if (current != null && (computed === undefined
          ? (current === current && !(0,_isSymbol_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(current))
          : comparator(current, computed)
        )) {
      var computed = current,
          result = value;
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["Z"] = (baseExtremum);


/***/ }),

/***/ 61303:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ lodash_es_max; }
});

// EXTERNAL MODULE: ./node_modules/lodash-es/_baseExtremum.js
var _baseExtremum = __webpack_require__(58000);
;// CONCATENATED MODULE: ./node_modules/lodash-es/_baseGt.js
/**
 * The base implementation of `_.gt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than `other`,
 *  else `false`.
 */
function baseGt(value, other) {
  return value > other;
}

/* harmony default export */ var _baseGt = (baseGt);

// EXTERNAL MODULE: ./node_modules/lodash-es/identity.js
var identity = __webpack_require__(69203);
;// CONCATENATED MODULE: ./node_modules/lodash-es/max.js




/**
 * Computes the maximum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * _.max([4, 2, 8, 6]);
 * // => 8
 *
 * _.max([]);
 * // => undefined
 */
function max(array) {
  return (array && array.length)
    ? (0,_baseExtremum/* default */.Z)(array, identity/* default */.Z, _baseGt)
    : undefined;
}

/* harmony default export */ var lodash_es_max = (max);


/***/ }),

/***/ 20625:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ lodash_es_min; }
});

// EXTERNAL MODULE: ./node_modules/lodash-es/_baseExtremum.js
var _baseExtremum = __webpack_require__(58000);
;// CONCATENATED MODULE: ./node_modules/lodash-es/_baseLt.js
/**
 * The base implementation of `_.lt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is less than `other`,
 *  else `false`.
 */
function baseLt(value, other) {
  return value < other;
}

/* harmony default export */ var _baseLt = (baseLt);

// EXTERNAL MODULE: ./node_modules/lodash-es/identity.js
var identity = __webpack_require__(69203);
;// CONCATENATED MODULE: ./node_modules/lodash-es/min.js




/**
 * Computes the minimum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the minimum value.
 * @example
 *
 * _.min([4, 2, 8, 6]);
 * // => 2
 *
 * _.min([]);
 * // => undefined
 */
function min(array) {
  return (array && array.length)
    ? (0,_baseExtremum/* default */.Z)(array, identity/* default */.Z, _baseLt)
    : undefined;
}

/* harmony default export */ var lodash_es_min = (min);


/***/ })

}]);